<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import Carregando from '~componentes/Carregando.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import ResumoAceite from './compartilhado/FormResumoAceite.vue';
  
  export default {
    components: {
      Carregando, DadosCadastrais, DadosBancarios,
      ResumoAceite, AdicionarArquivos, ListaDeArquivos
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        carregando: true,
        arquivos: [],
        arquivosNaoSalvos: [],
        habilitarFormResumoAceite: true,
        habilitarEditarDadosPessoaFisica: true,
        pessoa: {
          nomePessoaFisicaJuridica: '',
          dataNascimento: '',
          identidadeInscEstadual: '',
          inss: '',
          pisPasep: '',
          endereco: '',
          bairro: '',
          cidade: '',
          estado: '',
          cep: '',
          cpfCnpj: '',
          telefone1: '',
          telefone2: '',
          fax: '',
          email: '',
          tipoPessoaFisicaJuridica: '',

          nomeFantasia: '',
          carteiraTrabalhoInscMunicipal: '',
          contato: '',
          cargoFinanceiro: '',
          telContatoFinanceiro: '',
          contatoCompras: '',
          cargoCompras: '',
          telContatoCompras: '',
          emailCompras: '',
          emailPesquisa: '',
          dataAlteracaoAcessoWeb: '',
          webDadosBancarios: [],
        },
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Alterar cadastro';

      this.$root.botaoAcaoMostrar = false;
      
      this.carregar();
    },
    methods: {
      salvar() {
        $('#salvar').button('loading');

        this.$refs.dadosCadastrais
          .validar()
          .then((valido) => {
            return this.habilitarFormResumoAceite
              ? this.$refs.resumoAceite.validar(valido)
              : true;
          })
          .then(this.enviar)
          .then(dados => {
            $('#salvar').button('reset');

            toastr.success(`Dados alterados com sucesso.`);

            this.pessoa = dados;
          })
          .catch(erro => {
            $('#salvar').button('reset');


            this.$mensagemErro(erro);
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        this.$set(this.pessoa, 'arquivosDeletados', this.$refs.listaArquivos.deletados)
        this.pessoa.pessoaFisicaJuridicaResumoAceite = [this.$refs.resumoAceite.gerarObjetoDeDados()]
        const arquivos = this.$refs.adicionarArquivos.arquivos;

        return pessoaServico.alterarPessoa(this.pessoa, arquivos);
      },
      download(arquivo) {
        pessoaServico
          .download(this.pessoa.idPessoaFisicaJuridica, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      normalizarParaVisualizar(pessoa) {
        if (pessoa.inss) {
          pessoa.inss = pessoa.inss.replace('   .     .  / ', "");
        }

        if (pessoa.pispasep) {
          pessoa.pispasep = pessoa.pispasep.replace('   .     .  / ', "");
        }

        if (pessoa.dataNascimento) {
          pessoa.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);
        }

        return pessoa;
      },
      carregar() {
        this.carregando = true;
        this.habilitarEditarDadosPessoaFisica = this.usuario.habilitarEditarDadosPessoaFisica;
        
        return pessoaServico
          .pessoa()
          .then(dados => {
            this.pessoa = this.normalizarParaVisualizar(dados);
          })
          .then(() => pessoaServico.arquivos(this.pessoa.idPessoaFisicaJuridica))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.carregando = false;
          });
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="">

      <carregando v-if="carregando"></carregando>

      <div class="tabs-container" v-show="!carregando" id="tabs">

        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab"
               href="#tab-dados-cadastrais">
              Dados cadastrais
            </a>
          </li>
          <li>
            <a data-toggle="tab"
               href="#tab-dados-bancarios">
              Dados bancários
            </a>
          </li>
          <li v-if="configuracao.usarArquivosPessoas && habilitarEditarDadosPessoaFisica">
            <a data-toggle="tab"
               href="#tab-adicionar-arquivos">
              Adicionar arquivos
            </a>
          </li>
          <li v-if="configuracao.usarArquivosPessoas">
            <a data-toggle="tab"
               href="#tab-arquivos">
              Arquivos
            </a>
          </li>
          <li v-if="habilitarFormResumoAceite && habilitarEditarDadosPessoaFisica">
            <a data-toggle="tab"
               href="#tab-resumo-aceite">
              Resumo e aceite
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div id="tab-dados-cadastrais" class="tab-pane active">
            <div class="panel-body">
              <dados-cadastrais ref="dadosCadastrais"
                                :pessoa="pessoa"
                                :carregando="carregando"
                                :habilitarEditarDadosPessoaFisica="habilitarEditarDadosPessoaFisica">
              </dados-cadastrais>
            </div>
          </div>

          <div id="tab-dados-bancarios" class="tab-pane">
            <div class="panel-body">
              <dados-bancarios ref="dadosBancarios"
                               :dadosBancarios="pessoa.dadosBancarios"
                               :habilitarEditarDadosPessoaFisica="habilitarEditarDadosPessoaFisica">
              </dados-bancarios>
            </div>
          </div>

          <div id="tab-adicionar-arquivos" class="tab-pane">
            <div class="panel-body">
              <adicionar-arquivos ref="adicionarArquivos" v-model="arquivosNaoSalvos">
              </adicionar-arquivos>
            </div>
          </div>

          <div id="tab-arquivos" class="tab-pane">
            <div class="panel-body">
              <lista-de-arquivos :arquivos="arquivos"
                                 @download="download"
                                 ref="listaArquivos">
              </lista-de-arquivos>
            </div>
          </div>

          <div id="tab-resumo-aceite" class="tab-pane">
            <div class="panel-body">
              <resumo-aceite ref="resumoAceite"
                             :pessoa="pessoa"
                             :arquivos="arquivos"
                             :arquivosNaoSalvos="arquivosNaoSalvos">
              </resumo-aceite>
            </div>
          </div>
        </div>

      </div>

      <div class="row" v-show="!carregando">
        <div class="col-xs-9">
          <div class="form-group">
            <router-link
              class="btn btn-default"
              :to="{ name: 'home' }"
              active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
              id="salvar"
              type="button"
              class="btn btn-primary"
              @click="salvar"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando..."
              v-if="habilitarEditarDadosPessoaFisica">
                <i class="fa fa-save"></i>
                Salvar
            </button>
          </div>
        </div>
        <div class="col-xs-9">
          <span class="time-right" v-if="pessoa.dataAlteracaoAcessoWeb">
            Última atualização realizada em {{pessoa.dataAlteracaoAcessoWeb | formatarData }} às {{pessoa.dataAlteracaoAcessoWeb | formatarHora }}
          </span>
        </div>
      </div>
      
    </form>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/Alterar.vue